module.exports = __webpack_public_path__ + "img/payment-in-advance-skonto.af3530ad.png";